<template>
  <popup ref="popup" :appendToBody="true">
    <div slot="body">
      <el-form class="dataForm" ref="form" :model="formParameter" :inline="true" label-width="100px"
        :rules="rules">

        <el-row>
          <el-col :span="16">
            <el-form-item :label="$parent.Subflag + '名'" prop="name">  {{ formParameter.name }}   </el-form-item>
          </el-col>
          <el-col :span="8">
           
            <el-form-item  v-if="parameter.type == 9"    prop="level">
               <!--select-option-dictionary v-model="formParameter.level"
                    dkey="level"></select-option-dictionary--></el-form-item>
           <div  v-else>
                <el-button  v-has-permission-code-and="'004000200105'" size="mini"  v-if="parameter.type!= 9" type="warning" @click="add">新增 {{( this.parameter.type == 1 ? '技术文档' : ( this.parameter.type == 2 ? '授课视频' : ( this.parameter.type == 3 ? '学习笔记' : '代码附件')))   }}</el-button>
             </div>


          </el-col>
         </el-row>
          
        <el-row>
          <el-col :span="24">
            <el-divider content-position="left">  {{ this.$parent.Subflag }} {{ this.parameter.type==1?"文档":(this.parameter.type==2?"视频":"试卷" ) }} 列表</el-divider>
            <!-- 视频路径选项 -->
            <el-row v-for="(itm, index) in formParameter.res" v-bind:key="index">
              <el-col :span="1"  >
                 <el-form-item v-if="parameter.type!=9" >
                   <el-input    v-model="itm.sort"> </el-input>  
                  </el-form-item>
                  <el-form-item v-else >
                      {{index+1}}
                  </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item >
                  <el-input readonly v-model="itm.title"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item  >
                  <el-button  readonly> {{ itm.tname }} ~{{ itm.vtm }}</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="1"  v-if="parameter.type!=9" >
                     <el-link @click="delele(itm.title,itm.id)" type="primary" >删除</el-link>   
              </el-col>
              <el-col :span="4">
                     <div v-if="itm.type==4"   @click="doShow(itm)">下载</div>
                     <div v-else-if="itm.remarks && itm.remarks.indexOf('https')>=10 && itm.remarks.indexOf('https')<0" v-html="itm.remarks"></div>
                     <el-link v-else @click="doShow(itm)" type="primary" > 详情 </el-link>
              </el-col>
              <el-col :span="1" v-if="parameter.type<3">
                     <el-link :href="itm.url"   type="primary" target="_blank">打开URL</el-link>   
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <showvdo ref="showvdo"></showvdo>
      <showempr ref="showempr"></showempr>
    </div>
    <div slot="footer">
      <el-button @click="close">关 闭</el-button><el-button v-if="parameter.type!=9" type="success" @click="sorts">更新序号</el-button>
      
    </div>
  

  </popup>

</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/edu/subject/subject.js";
import showvdo from "@/views/edu/videoes/edit.vue";
import apiVdo from '@/api/edu/videoes/videoes.js'
import showempr from "@/views/exams/exampaper/edtails.vue";


import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
export default {
  name: "edit",
  components: {
    popup,showvdo,showempr,
    selectOptionDictionary,
  },
  data() {
    return {
 
      disabled: false,
      popupLoading: false,
      parameter: {},
      formParameter: { },
      rules:{}

    };
  },
  methods: {

    delele(title,id){
      this.$utils.confirm.warning('删除提示', '确定删除 ['+title+'] 吗？', () => {
        
        apiVdo.remove(
          {ids: id},
          response => {
            this.$utils.msg.success(response.msg)
            this.list()
          },
          response => {
            this.$utils.msg.warning(response.msg)
          }
        )

      })

    },

    add(){
 
      if(this.parameter.type != 9){ 
          this.$refs.showvdo.openInShow({kid:this.parameter.id,name:this.formParameter.name},  this.parameter.type,  false,this)
      } 

    },
    sorts(){
      let arr = []
      this.formParameter.res.forEach(v=>{
         if(v.sort){
          arr.push({id:v.id,sort:v.sort})
         }
      })

      apiVdo.updtSorts({type:1,videoes:arr},sucss=>{
         //编辑查询数据
         let parameter = {
            id: this.parameter.id,
           type: this.parameter.type
          };
          api.getOne(parameter, (response) => {
             this.formParameter = response.data;
             this.$forceUpdate()
          });
      })


    },
    doShow(itm){

      console.log("itm",itm)

      let detailParameter = {
        id: itm.id
      }
      this.popupLoading=false
      if(this.parameter.type==9){
        this.$refs.showempr.open(detailParameter,  "查看试卷" ,  true)
      }else{
     
        this.$refs.showvdo.open(detailParameter,  this.parameter.type,  true)
      }
   
      this.popupLoading=false

    },
    //打开弹框
    open(parameter, title, disabled, size) {

      

      this.parameter = parameter;
      this.$refs.popup.open(title, 1600);
      this.$nextTick(() => {
        this.list();
      });
    },
    //关闭弹框
    close() {
      this.$refs.popup.close();
    },
    list() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = { };
      //清楚校验
      this.$refs.form.clearValidate();

        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
          type: this.parameter.type
        };
        api.getOne(parameter, (response) => {
          this.formParameter = response.data;
        });
        this.popupLoading = false;
     
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";



</style>